import { IPurchasingGroupAssignmentDto } from '../types/purchasing-group-assignment.dto';

export class PurchasingGroupAssignment {
    public readonly id: string;
    public readonly companyCodeId: string;
    public readonly companyCode: string;
    public readonly companyCodeName: string | null;
    public readonly materialGroupId: string;
    public readonly materialGroupCode: string;
    public readonly materialGroupName: string | null;
    public readonly key: string;
    public readonly companyCodeLabel: string;
    public readonly materialGroupLabel: string;

    constructor(dto: IPurchasingGroupAssignmentDto) {
        this.id = dto.id;
        this.companyCodeId = dto.companyCodeId;
        this.companyCode = dto.companyCode;
        this.companyCodeName = dto.companyCodeName ?? null;
        this.materialGroupId = dto.materialGroupId;
        this.materialGroupCode = dto.materialGroupCode;
        this.materialGroupName = dto.materialGroupName ?? null;
        this.key = `${this.companyCodeId}::${this.materialGroupId}`;
        this.companyCodeLabel = buildLabel(this.companyCode, this.companyCodeName);
        this.materialGroupLabel = buildLabel(this.materialGroupCode, this.materialGroupName);
    }
}

function buildLabel(code: string, name: string | null): string {
    const trimmedName = name?.trim();
    if (!trimmedName) {
        return code;
    }
    return `${code} - ${trimmedName}`;
}
